import * as React from 'react'

/**
 * Wymusza przerysowanie co sekundę, dopóki `active` jest prawdziwe.
 *
 * Potrzebne tam, gdzie pokazujemy upływający czas zadania: sam licznik postępu stoi
 * przez całą fazę liczenia danych, więc bez tykającego zegara ekran wygląda jak
 * zawieszony, mimo że praca trwa. Nic nie zwraca — liczy się sam efekt renderowania.
 */
export const useElapsedTick = (active: boolean): void => {
  const [, force] = React.useReducer((n: number) => n + 1, 0)

  React.useEffect(() => {
    if (!active) return undefined
    const id = window.setInterval(force, 1000)
    return () => window.clearInterval(id)
  }, [active])
}
